import React from 'react';
import ProductItem from './product-item'

//https://reactjs.org/docs/lists-and-keys.html
class ProductList extends React.Component {

	render() {

		let data = this.props.products;

		return (
			<ul className="product-list">
				{data.map((product, index) =>
					<ProductItem key={product.id_product} data={product} index={index} />
				)}
			</ul>			

		);
	}
}	

export default ProductList;